import { PmDRSDatalayer } from "../Datalayer/PmDRSDatalayer";
import { DOMHelper } from "../Helpers/DOMHelper";

export class AdditionalStepsSection {
    constructor(app) {
        this.app = app;
        this.parentId = app.config.elementId;
        this.classAt = "additiona-steps-section";
    }

    init(containerElement) {
        containerElement.insertAdjacentHTML("beforeend", this.getHtml());
        this.eventHandlers();
    }

    setBackground(make) {
        let background = make.toLowerCase() == "indian motorcycle" ? "indian-background" : "bmw-background";
        DOMHelper.addClass(document.querySelector(this.app.getSelector(".scheduleTestRideBtn")), background);
        DOMHelper.addClass(document.querySelector(this.app.getSelector(".submitTestRide")), background);
        DOMHelper.addClass(document.querySelector(this.app.getSelector(".preApprovedBtn")), background);
        DOMHelper.addClass(document.querySelector(this.app.getSelector(".submitPreApproved")), background);
    }

    eventHandlers() {
        // show schedule test ride form on additional steps section
        DOMHelper.addHandler(this.app.getSelector(".scheduleTestRideBtn"), "click", () => {
            // DOMHelper.addClass(dealPage.getSelector(".test-ride-card"), "d-none");
            DOMHelper.addClass(this.app.getSelector(".test-ride-body"), "visible");
            let testRideSection = document.querySelector(this.app.getSelector(".additional-steps .test-ride-card"));
            testRideSection.scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "nearest",
            });
        });

        // hide schedule test ride from on additional steps section
        DOMHelper.addHandler(this.app.getSelector(".test-ride-body-title"), "click", () => {
            // DOMHelper.addClass(dealPage.getSelector(".test-ride-body"), "d-none");
            DOMHelper.removeClass(this.app.getSelector(".test-ride-body"), "visible");
        });

        // show pre approved form on additional steps section
        DOMHelper.addHandler(this.app.getSelector(".preApprovedBtn"), "click", () => {
            // here it goes
            if (this.app.pmdrs.config.accountId == "delamomotorsports") {
                window.open('https://www.delamomotorsports.com/get-pre-approved/', '_blank');
                return;
            }
            // DOMHelper.addClass(dealPage.getSelector(".pre-approved-card"), "d-none");
            DOMHelper.addClass(this.app.getSelector(".pre-approved-body"), "visible");
            let preApprovedSection = document.querySelector(this.app.getSelector(".additional-steps .pre-approved-card"));
            preApprovedSection.scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "nearest",
            });
        });

        DOMHelper.addHandler(this.app.getSelector(".pre-approved-body-title"), "click", () => {
            // DOMHelper.addClass(dealPage.getSelector(".pre-approved-card"), "d-none");
            DOMHelper.removeClass(this.app.getSelector(".pre-approved-body"), "visible");
        });

        // submit schedule test ride form
        DOMHelper.addHandler(this.app.getSelector(".submitTestRide"), "click", (event) => {
            const leadId = this.app.generateLeadId();
            const ftid = this.app.generateFTID(leadId);
            let valid = this.validateScheduleTestRide();
            if (valid) {
                document.querySelector(this.app.getSelector(".deal-page-spinner")).style.display = "block";
                let firstname = document.querySelector(this.app.getSelector("#TRFirstName")).value;
                let lastname = document.querySelector(this.app.getSelector("#TRLastName")).value;
                let phone = document.querySelector(this.app.getSelector("#TRPhone")).value;
                let email = document.querySelector(this.app.getSelector("#TREmail")).value;
                let date = document.querySelector(this.app.getSelector("#testRideDate")).value;
                let time = document.querySelector(this.app.getSelector("#TRTime")).value;
                let site_token = this.app.pmdrs.config.accountId;
                let user_agent = navigator.userAgent;
                let source_origin = window.location.origin;
                let source_url = window.location.href.replace(window.location.origin, "").substring(1);
                let make = this.app.config.vehicle.make;
                let model = this.app.config.vehicle.model;
                let trim = this.app.config.vehicle.trim;
                let vehicleField = {
                    vin: this.app.config.vehicle.vin,
                    stockNum: this.app.config.vehicle.stockNumber,
                    label: this.app.config.vehicle.label,
                    year: this.app.config.vehicle.year,
                    msrp: this.app.getVehicleRetailPrice(),
                    make: this.app.config.vehicle.make,
                    model: model,
                    trim: trim,
                    key: `${this.app.config.vehicle.year}${make.toLowerCase()}${model.toLowerCase()}${trim
                        .toLowerCase()
                        .replace(/\s/g, "")}`,
                };

                let testRideForm = new FormData();
                let entry = {
                    source_url: source_url,
                    firstField: firstname,
                    lastField: lastname,
                    phoneField: phone,
                    emailField: email,
                    dateField: date,
                    timeField: time,
                    makeField: make,
                    modelField: model,
                    trimField: trim,
                    yearField: this.app.config.vehicle.year,
                    vinField: this.app.config.vehicle.vin,
                };
                let form = {
                    id: 5,
                    title: "Schedule Test Ride",
                    PMForm: true,
                };
                testRideForm.set("leadId", leadId);
                testRideForm.set("ftid", ftid);

                testRideForm.set("site_token", site_token);
                testRideForm.set("entry", JSON.stringify(entry));
                testRideForm.set("form", JSON.stringify(form));
                testRideForm.set("isFca", this.app.pmdrs.config.oem);
                testRideForm.set("sessionId", this.app.pmDRSDatalayer.getSessionId());
                testRideForm.set("user_agent", user_agent);
                testRideForm.set("source_url", source_url);
                testRideForm.set("source_origin", source_origin);
                testRideForm.set("multiDealer", this.app.pmdrs.config.isMultiDealer);
                testRideForm.set("vehicle", JSON.stringify(vehicleField));

                this.app.pmdrs.pmApiDtm.postNoDRSLead(
                    testRideForm,
                    (successCallback) => {
                        document.querySelector(this.app.getSelector(".deal-page-spinner")).style.display = "none";
                        console.log(JSON.parse(successCallback));
                        document.querySelector(this.app.getSelector(".test-ride-success .success-msg")).style.display =
                            "block";
                        DOMHelper.removeClass(this.app.getSelector(".test-ride-body"), "visible");
                        // setTimeout(() => {
                        //     document.querySelector(
                        //         this.app.getSelector(".test-ride-success .success-msg")
                        //     ).style.display = "none";
                        // }, 5000);

                        //DATALAYER
                        this.app.shiftDatalayer.fireEvent('drApptSchedFinish');
                        this.app.pmDRSDatalayer.submitEvent(PmDRSDatalayer.SCHEDULE_TEST_RIDE_SECTION, 'submit button', event.target, leadId, this.app.config.vehicle);

                        this.app.pmdrsForms.stellantisHashEmail(email)
                            .then((hashedEmail) =>{
                                this.app.adobeDtmDatalayer.fireEvent('formSubmit', {
                                    formType: 'test-ride', 
                                    leadId: ftid,
                                    hashedEmail
                                });
                            });
                        setTimeout(() => {
                            let data = {
                                CJId: this.app.dealPage.customerJourneyId,
                                sessionId: this.app.pmDRSDatalayer.getSessionId()
                            };
                            this.app.pmdrs.pmCustomerAPI.addAdditionalStepsToCJ(data, 
                                (success) => {
                                    console.log(success);
                                }, 
                                (xhr, status, error) => {
                                    console.log(xhr);
                                    console.log(status)
                                    console.log(JSON.parse(error));
                                }
                            );
                        }, 2000);
                    },
                    (error) => {
                        console.log(error);
                    }
                );
            } else {
                console.log("FILL ALL FIELDS");
            }
        });

        // submit get pre-approved form
        DOMHelper.addHandler(this.app.getSelector(".submitPreApproved"), "click", (event) => {
            const leadId = this.app.generateLeadId();
            const ftid = this.app.generateFTID(leadId);
            let valid = this.validatePreApprovedForm();
            if (valid) {
                document.querySelector(this.app.getSelector(".deal-page-spinner")).style.display = "block";
                let firstname = document.querySelector(this.app.getSelector("#PAName")).value;
                let lastname = document.querySelector(this.app.getSelector("#PALastName")).value;
                let phone = document.querySelector(this.app.getSelector("#PAPhone")).value;
                let email = document.querySelector(this.app.getSelector("#PAEmail")).value;
                let streetAddress = document.querySelector(this.app.getSelector("#PAStreet")).value;
                let addLine2 = document.querySelector(this.app.getSelector("#PAAddressLine2")).value;
                let city = document.querySelector(this.app.getSelector("#PACity")).value;
                let state = document.querySelector(this.app.getSelector("#PAState")).value;
                let zip = document.querySelector(this.app.getSelector("#PAZipCode")).value;
                let site_token = this.app.pmdrs.config.accountId;
                let user_agent = navigator.userAgent;
                let source_origin = window.location.origin;
                let source_url = window.location.href.replace(window.location.origin, "").substring(1);
                let make = this.app.config.vehicle.make;
                let model = this.app.config.vehicle.model;
                let trim = this.app.config.vehicle.trim;
                let vehicleField = {
                    vin: this.app.config.vehicle.vin,
                    stockNum: this.app.config.vehicle.stockNumber,
                    label: this.app.config.vehicle.label,
                    year: this.app.config.vehicle.year,
                    msrp: this.app.getVehicleRetailPrice(),
                    make: this.app.config.vehicle.make,
                    model: model,
                    trim: trim,
                    key: `${this.app.config.vehicle.year}${make.toLowerCase()}${model.toLowerCase()}${trim
                        .toLowerCase()
                        .replace(/\s/g, "")}`,
                };
                let preApprovedForm = new FormData();
                let entry = {
                    source_url: source_url,
                    firstField: firstname,
                    lastField: lastname,
                    phoneField: phone,
                    emailField: email,
                    streetField: streetAddress,
                    addressLineField: addLine2,
                    cityField: city,
                    stateField: state,
                    zipField: zip,
                    makeField: make,
                    modelField: model,
                    trimField: trim,
                    yearField: this.app.config.vehicle.year,
                    vinField: this.app.config.vehicle.vin,
                };
                let form = {
                    id: 7,
                    title: "Get Pre-Approved",
                    PMForm: true,
                };
                preApprovedForm.set("leadId", leadId);
                preApprovedForm.set("ftid", ftid);
                preApprovedForm.set("site_token", site_token);
                preApprovedForm.set("entry", JSON.stringify(entry));
                preApprovedForm.set("form", JSON.stringify(form));
                preApprovedForm.set("isFca", this.app.pmdrs.config.oem);
                preApprovedForm.set("sessionId", this.app.pmDRSDatalayer.getSessionId());
                preApprovedForm.set("user_agent", user_agent);
                preApprovedForm.set("source_url", source_url);
                preApprovedForm.set("source_origin", source_origin);
                preApprovedForm.set("multiDealer", this.app.pmdrs.config.isMultiDealer);
                preApprovedForm.set("vehicle", JSON.stringify(vehicleField));

                this.app.pmdrs.pmApiDtm.postNoDRSLead(
                    preApprovedForm,
                    (successCallback) => {
                        document.querySelector(this.app.getSelector(".deal-page-spinner")).style.display = "none";
                        console.log(JSON.parse(successCallback));
                        document.querySelector(
                            this.app.getSelector(".pre-approved-success .success-msg")
                        ).style.display = "block";
                        DOMHelper.removeClass(this.app.getSelector(".pre-approved-body"), "visible");
                        // setTimeout(() => {
                        //     document.querySelector(
                        //         this.app.getSelector(".pre-approved-success .success-msg")
                        //     ).style.display = "none";
                        // }, 2500);
                        //DATALAYER
                        this.app.shiftDatalayer.fireEvent('drPreQFinish');
                        this.app.pmDRSDatalayer.submitEvent(PmDRSDatalayer.PRE_APPROVED_SECTION, 'submit button', event.target, leadId, this.app.config.vehicle);

                        this.app.pmdrsForms.stellantisHashEmail(email)
                            .then((hashedEmail) =>{
                                this.app.adobeDtmDatalayer.fireEvent('formSubmit', {
                                    formType: 'get-pre-approved', 
                                    leadId: ftid,
                                    hashedEmail
                                });
                            });

                    },
                    (error) => {
                        console.log(error);
                    }
                );
            }
        });
    }

    validateScheduleTestRide() {
        const $this = this;
        let valid = true;
        let ids = ["TRFirstName", "TRLastName", "TRPhone", "TREmail", "testRideDate"];
        var shiftFormErrorSent = false;

        ids.forEach((id) => {
            let element = document.querySelector(this.app.getSelector("#" + id));
            let error = document.querySelector(this.app.getSelector("." + id + "-error"));
            if (element.value.length == 0) {
                error.style.display = "block";
                valid = false;
                //Datalayer
                if(!shiftFormErrorSent){
                    $this.app.adobeDtmDatalayer.fireEvent('formError', {errorMessage:'This field is required.'});
                    shiftFormErrorSent = true;
                }
            } else {
                error.style.display = "none";
            }
        });

        return valid;
    }

    validatePreApprovedForm() {
        const $this = this;
        let valid = true;
        let ids = [
            "PAName",
            "PALastName",
            "PAPhone",
            "PAEmail",
            "PAStreet",
            // "PAAddressLine2",
            "PACity",
            "PAState",
            "PAZipCode",
        ];
        var shiftFormErrorSent = false;
        ids.forEach((id) => {
            let element = document.querySelector(this.app.getSelector("#" + id));
            let error = document.querySelector(this.app.getSelector("." + id + "-error"));

            let isFieldValid = true;

            if (element.type === "text") {
                const isEmpty = element.value.trim().length === 0;
                if (isEmpty) {
                    isFieldValid = false;
                    // Additional actions for empty text input
                }
                error.style.display = isEmpty ? "block" : "none";
            } else {
                const isDefault = element.value === "default";
                if (isDefault) {
                    isFieldValid = false;
                    // Additional actions for default selection
                }
                error.style.display = isDefault ? "block" : "none";
            }

            // Combine with overall form validity
            if (!isFieldValid) {
                valid = false;
                // Add more global invalid actions here if needed
                //Datalayer
                if(!shiftFormErrorSent){
                    $this.app.adobeDtmDatalayer.fireEvent('formError', {errorMessage:'This field is required.'});
                    shiftFormErrorSent = true;
                }
            }
        });

        
        return valid;
    }

    show() {
        DOMHelper.removeClass(this.app.getSelector(".additional-steps"), "d-none");
    }

    hide() {
        DOMHelper.addClass(this.app.getSelector(".additional-steps"), "d-none");
    }

    populateAdditionalStepsSection() {
        //let testRideVideo = this.app.getYoutubeTestRideVideo();
        //let preApprovedVideo = this.app.getYoutubePreApprovedVideo();
        this.app.dealPage.populateStatesSelect();

        // to show the video or the icon
        //let iframeTestRide = document.querySelector(this.app.getSelector("#test-ride-video"));
        // if (testRideVideo && testRideVideo.length > 0) {
        //     DOMHelper.addClass(this.app.getSelector("#test-ride-img"), "d-none");
        //     if (iframeTestRide) {
        //         iframeTestRide.src = testRideVideo.replace("watch?v=", "embed/") + "?modestbranding=0&reo=0&showinfo=0";
        //     }
        // } else {
        //     DOMHelper.addClass(this.app.getSelector("#test-ride-video"), "d-none");
        //     let img = this.app.pmdrs.pmApi.getRootURL() + "dist/img/schedule-test-ride-no-video.jpg";
        //     let imgTestRide = document.querySelector(this.app.getSelector("#test-ride-img"));
        //     imgTestRide.src = img;
        // }
        DOMHelper.addClass(this.app.getSelector("#test-ride-video"), "d-none");
        let site_token = this.app.pmdrs.config.accountId;
        const isFCA = this.app.pmdrs.isFCA();
        let img = "";
        if (this.app.isVehicleStellantis()) {
            img = this.app.pmdrs.pmApi.getRootURL() + "dist/img/jeep1.avif";
        } else if (this.app.isVehiclePolaris()) {
            img = this.app.pmdrs.pmApi.getRootURL() + "dist/img/test-ride-polaris.jpg";
        } else if (this.app.isVehicleFord()) {
            img = this.app.pmdrs.pmApi.getRootURL() + "dist/img/imageford1.png";
        } else {
            img = this.app.pmdrs.pmApi.getRootURL() + "dist/img/schedule-test-ride-no-video.jpg";
        }
        // let img = this.app.pmdrs.pmApi.getRootURL() + "dist/img/schedule-test-ride-no-video.jpg";
        let imgTestRide = document.querySelector(this.app.getSelector("#test-ride-img"));
        imgTestRide.src = img;

        // let iframePreApproved = document.querySelector(this.app.getSelector("#pre-approved-video"));
        // if (preApprovedVideo && preApprovedVideo.length > 0) {
        //     DOMHelper.addClass(this.app.getSelector("#pre-approved-img"), "d-none");
        //     if (iframePreApproved) {
        //         iframePreApproved.src =
        //             preApprovedVideo.replace("watch?v=", "embed/") + "?modestbranding=0&reo=0&showinfo=0";
        //     }
        // } else {
        //     DOMHelper.addClass(this.app.getSelector("#pre-approved-video"), "d-none");
        //     let img = this.app.pmdrs.pmApi.getRootURL() + "dist/img/get-pre-approved-no-video.jpg";
        //     let imgPreApproved = document.querySelector(this.app.getSelector("#pre-approved-img"));
        //     imgPreApproved.src = img;
        // }
        // ************************ PRE APPROVED SECTION ************************
        DOMHelper.addClass(this.app.getSelector("#pre-approved-video"), "d-none");
        let img2 = "";
        if (this.app.isVehicleStellantis()) {
            img2 = this.app.pmdrs.pmApi.getRootURL() + "dist/img/jeep2.jpg";
        } else if (this.app.isVehiclePolaris()) {
            img2 = this.app.pmdrs.pmApi.getRootURL() + "dist/img/pre-approved-polaris.webp";
        } else if (this.app.isVehicleFord()) {
            img2 = this.app.pmdrs.pmApi.getRootURL() + "dist/img/imageford2.jpg";
        } else {
            img2 = this.app.pmdrs.pmApi.getRootURL() + "dist/img/get-pre-approved-no-video.jpg";
        }
        // let img2 = this.app.pmdrs.pmApi.getRootURL() + "dist/img/get-pre-approved-no-video.jpg";
        let imgPreApproved = document.querySelector(this.app.getSelector("#pre-approved-img"));
        imgPreApproved.src = img2;

        DOMHelper.addClass(this.app.getSelector("#deal-page-stepper"), "d-none");
        DOMHelper.addClass(this.app.getSelector("#stepper-place"), "d-none");
        this.show();

        // populate the additional steps forms
        let firstname = document.querySelector(this.app.getSelector(".ciFirstName")).value;
        let lastname = document.querySelector(this.app.getSelector(".ciLastName")).value;
        let phone = document.querySelector(this.app.getSelector(".ciMobileNumber")).value;
        let email = document.querySelector(this.app.getSelector(".ciEmail")).value;

        // test ride form
        document.querySelector(this.app.getSelector("#TRFirstName")).value = firstname;
        document.querySelector(this.app.getSelector("#TRLastName")).value = lastname;
        document.querySelector(this.app.getSelector("#TRPhone")).value = phone;
        document.querySelector(this.app.getSelector("#TREmail")).value = email;

        // get pre approved form
        document.querySelector(this.app.getSelector("#PAName")).value = firstname;
        document.querySelector(this.app.getSelector("#PALastName")).value = lastname;
        document.querySelector(this.app.getSelector("#PAPhone")).value = phone;
        document.querySelector(this.app.getSelector("#PAEmail")).value = email;
        // document.querySelector(this.getSelector("#deal-page-stepper")).style.display = "none";

        this.scrollToSection();
    }

    scrollToSection() {
        // scroll into the additional steps section
        let additionalStepsSection = document.querySelector(this.app.getSelector(".additional-steps"));
        additionalStepsSection.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest",
        });
    }

    getHtml() {
        return `<div class="additional-steps d-none">
    <!-- <p class="title">
        ADDITIONAL STEPS (optional)
    </p> -->

    <div class="additional-steps-body">
        <div class="test-ride d-none">
            <div class="test-ride-card">
                <div class="test-ride-card-body">
                    <div class="video">
                        <iframe src="" frameborder="0" id="test-ride-video" allowfullscreen="true" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"></iframe>
                        <img src="" alt="test-ride-img" id="test-ride-img">
                    </div>
                    <div class="text">
                        <p>Schedule a Test Ride</p>
                        <span>
                            Schedule a test ride at a time and date that is convenient for you
                        </span>
                        <button type="button" class="scheduleTestRideBtn color-white" ><i class="pmdrs-fa pmdrs-fa-clock"></i>Schedule Now</button>
                        <div class="test-ride-success">
                            <p class="success-msg">Sent correctly!</p>
                        </div>
                    </div>
                </div>

                <div class="test-ride-body">
                    <p class="test-ride-body-title">Schedule a Test Ride <i class="pmdrs-fa pmdrs-fa-angle-down"></i> </p>
                    <span>
                        Schedule a test ride at a time and date that is convenient for you
                    </span>
                    <div class="test-ride-group">
                        <label class="text-us-label" for="TRFirstName">First Name</label>
                        <input placeholder="Enter First Name" type="text" id="TRFirstName" class="text-us-input information-input" name="testRideFirstName">
                        <p class="error-input-additional-steps TRFirstName-error">This field is required.</p>
                    </div>
                    <div class="test-ride-group">
                        <label class="text-us-label" for="TRLastName">Last Name</label>
                        <input placeholder="Enter Last Name" type="text" id="TRLastName" class="text-us-input information-input" name="testRideLastName">
                        <p class="error-input-additional-steps TRLastName-error">This field is required.</p>
                    </div>
                    <div class="test-ride-group">
                        <label class="text-us-label" for="TRPhone">Phone</label>
                        <input placeholder="Enter Phone" type="text" id="TRPhone" class="text-us-input information-input" name="testRidePhone">
                        <p class="error-input-additional-steps TRLastName-error TRPhone-error">This field is required.</p>
                    </div>
                    <div class="test-ride-group">
                        <label class="text-us-label" for="TREmail">Email</label>
                        <input placeholder="Enter Email" type="text" id="TREmail" class="text-us-input information-input" name="testRideEmail">
                        <p class="error-input-additional-steps TRLastName-error TREmail-error">This field is required.</p>
                    </div>
                    <div class="test-ride-group">
                        <div class="drs-option-wrapper drs-input-wrapper drs-input-wrapper-icon vertical-center testRideDate">
    <div class="drs-label-left">
        <label for="testRideDate">
            <p style="display: inline;"><strong>Date</strong></p>
            <span></span>
        </label>
        <span class="description"></span>
    </div>
    <div class="drs-input-right drs-input-container">
        <input @@multiple type="date" accept="@@accept" name="testRideDate" id="testRideDate" placeholder="dd-mm-yyyy" @@required>
        <p class="error-input testRideDate">This field is required.</p>
        <p class="error-input testRideDate">Please check the format.</p>
        
    </div>
</div>
                        <p class="error-input-additional-steps TRLastName-error testRideDate-error">This field is required.</p>
                    </div>
                    <div class="test-ride-group">
                        <label class="text-us-label" for="TRTime">Time</label>
                        <select name="TRTime" id="TRTime" class="information-input">
                            <option value="morning">Morning</option>
                            <option value="afternoon">Afternoon</option>
                            <option value="evening">Evening</option>
                        </select>
                    </div>
                    <button class="color-white submitTestRide" type="button">Submit</button>
                </div>
            </div>

        </div>
        <div class="pre-approved">
            <div class="pre-approved-card">
                <div class="pre-approved-card-body">
                    <div class="video">
                        <iframe src="" frameborder="0" id="pre-approved-video" allowfullscreen="true" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"></iframe>
                        <img src="" alt="pre-approved-img" id="pre-approved-img">
                    </div>
                    <div class="text">
                        <p>Get Pre-Approved</p>
                        <span>
                            Apply to get pre-approved now by clicking the button below.
                        </span>
                        <button type="button" class="preApprovedBtn color-white"><i class="pmdrs-fa pmdrs-fa-check-circle"></i>Get Started</button>
                        <div class="pre-approved-success">
                            <p class="success-msg">Sent correctly!</p>
                        </div>
                    </div>
                </div>
                <div class="pre-approved-body">
                    <p class="pre-approved-body-title">Get Pre-Approved <i class="pmdrs-fa pmdrs-fa-angle-down"></i></p>
                    <span>
                        Apply to get pre-approved now by clicking the button below.
                    </span>
                    <div class="pre-approved-group">
                        <label class="text-us-label" for="PAName">First Name</label>
                        <input placeholder="Enter First Name" type="text" id="PAName" class="text-us-input information-input" name="approvedName">
                        <p class="error-input-additional-steps PAName-error">This field is required.</p>
                    </div>
                    <div class="pre-approved-group">
                        <label class="text-us-label" for="PALastName">Last Name</label>
                        <input placeholder="Enter Last Name" type="text" id="PALastName" class="text-us-input information-input" name="approvedLastName">
                        <p class="error-input-additional-steps PALastName-error">This field is required.</p>
                    </div>
                    <div class="pre-approved-group">
                        <label class="text-us-label" for="PAPhone">Phone</label>
                        <input placeholder="Enter Phone" type="text" id="PAPhone" class="text-us-input information-input" name="approvedPhone">
                        <p class="error-input-additional-steps PAPhone-error">This field is required.</p>
                    </div>
                    <div class="pre-approved-group">
                        <label class="text-us-label" for="PAEmail">Email</label>
                        <input placeholder="Enter Email" type="text" id="PAEmail" class="text-us-input information-input" name="approvedEmail">
                        <p class="error-input-additional-steps PAEmail-error">This field is required.</p>
                    </div>
                    <div class="pre-approved-group">
                        <label class="text-us-label" for="PAStreet">Street Address</label>
                        <input placeholder="Enter Street Address" type="text" id="PAStreet" class="text-us-input information-input" name="PAStreet">
                        <p class="error-input-additional-steps PAStreet-error">This field is required.</p>
                    </div>
                    <div class="pre-approved-group">
                        <label class="text-us-label" for="PAAddressLine2">Address Line 2</label>
                        <input placeholder="Enter Address Line 2" type="text" id="PAAddressLine2" class="text-us-input information-input" name="PAAddressLine2">
                        <p class="error-input-additional-steps PAAddressLine2-error">This field is required.</p>
                    </div>
                    <div class="pre-approved-group">
                        <label class="text-us-label" for="PACity">City</label>
                        <input placeholder="Enter City" type="text" id="PACity" class="text-us-input information-input" name="PACity">
                        <p class="error-input-additional-steps PACity-error">This field is required.</p>
                    </div>
                    <div class="pre-approved-group">
                        <label class="text-us-label" for="PAState">State</label>
                        <select class="retailing-pastate-select information-input" name="PAState" id="PAState"></select>
                        <p class="error-input-additional-steps PAState-error">This field is required.</p>
                    </div>
                    <div class="pre-approved-group">
                        <label class="text-us-label" for="PAZipCode">ZIP Code</label>
                        <input placeholder="Enter ZIP Code" type="text" id="PAZipCode" class="text-us-input information-input" name="PAZipCode">
                        <p class="error-input-additional-steps PAZipCode-error">This field is required.</p>
                    </div>
                    <button class="color-white submitPreApproved" type="button">Submit</button>
                </div>
            </div>
        </div>
        <!-- Schedule a Test Drive — own gray card, per Jake's mockup (just Date + Time, no
             location-choice/address sub-flow — that's the separate, bigger step-schedule-delivery.html,
             which isn't wired into the widget at all currently). Additive only: distinct field
             names (testDriveDateField/testDriveTimeField) from the existing Test Ride feature
             above so the two don't collide if this section is ever unhidden. Still inside the
             .additional-steps d-none wrapper — this whole section isn't used by any account
             right now, so this is dead code for the moment, per Jose. -->
        <div class="schedule-test-drive-section">
            <div class="schedule-test-drive-title">Schedule a Test Drive</div>
            <div class="schedule-test-drive-subtitle">Would you like to set up an appointment for a test drive?</div>
            <div class="contact-form">
                <div class="contact-form-group">
                    <label class="contact-form-label" for="testDriveDate">Date</label>
                    <input name="testDriveDateField" id="testDriveDate" class="contact-form-input" type="date" />
                </div>
                <div class="contact-form-group">
                    <label class="contact-form-label" for="testDriveTime">Time</label>
                    <input name="testDriveTimeField" id="testDriveTime" class="contact-form-input" type="time" />
                </div>
            </div>
        </div>

        <div class="additional-steps-footer">
            <!-- <button type="button" class="closeAdditionalSteps bg-blue color-white">Close</button> -->
        </div>
    </div>
</div>`;
    }

    getSelector(selector) {
        return this.app.getSelector("." + this.classAtt + " " + selector);
    }
}
